export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8812.464a9204.jpg";